class ProfessionalListModal {
    constructor() {
        this.modal = $('#professionalListModal');
        this.registerEvents();
    }

    registerEvents() {
        $(document).ready(() => {
            return this.showModal();
        });

        return this.modal.on('click', '.btn', e => {
            return this.handleInput(e);
        });
    }

    showModal() {
        return setTimeout((() => {
            return this.modal.modal('show');
        }), 500);
    }

    hideModal() {
        return this.modal.modal('hide');
    }

    handleInput(e) {
        e.preventDefault();
        const $btn = $(e.currentTarget);
        const shouldContinue = $btn.data('continue');

        if (shouldContinue) {
            const form = $('form#registerPersonalDetails');
            form.append('<input type="hidden" name="ignore_verification" value="true" />');
            form.submit();
            return;
        }

        return this.hideModal();
    }
}

export default ProfessionalListModal;
